export const styles = {
  languageSelector: (theme) => ({
    position: "relative",
    zIndex: theme.zIndex.z2,
    transitionDuration: "100ms",
    backgroundColor: theme.palette.background.default,
    borderRadius: "10px",

    "& svg": {
      marginLeft: "0.5rem",
    },
  }),
  languageSelectorButton: (theme) => ({
    textTransform: "none",
    fontWeight: "normal",
    color: theme.palette.common.black,
    border: `1px solid ${theme.palette.border.primary}`,
    "&:hover": {
      border: `1px solid ${theme.palette.border.primary}`,
      boxShadow: `${theme.palette.border.primary} 0px 1px 4px`,
    },
  }),
}
